import { gql } from 'apollo-angular';

/**
 * Mutations related to authentication.
 */
export class AuthenticationMutations {
	public static createOneTimeToken = gql`
		mutation createOneTimeToken {
			createOneTimeToken
		}
	`;
}
